// extracted by mini-css-extract-plugin
module.exports = {"content":"a10a3f92e9--content--wu7_W","button":"a10a3f92e9--button--pOMx2"};